import { useState } from 'react';
import { lineItemPhotoSource, type LineItemPhotoSource } from '@/lib/sales/line-item-photo';

/** A catalog photo beside a customer-visible line; absent/failed media takes no space. */
export function LineItemPhoto({ line }: { line: LineItemPhotoSource & { name: string } }) {
  const src = lineItemPhotoSource(line);
  return src ? <Photo key={src} src={src} name={line.name} /> : null;
}

function Photo({ src, name }: { src: string; name: string }) {
  const [failed, setFailed] = useState(false);
  if (failed) return null;
  return (
    <img
      src={src}
      alt={name}
      loading="lazy"
      onError={() => setFailed(true)}
      className="size-12 shrink-0 rounded-md border border-[#14141A]/[0.08] object-contain"
    />
  );
}
